var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#39B54A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,482h-30V180h-91v302h-30V300h-90v182h-30V240h-90v242h-30V330H30v152H0v30h512V482z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,120V0H391v30h69.8L316,173.8l-120-120L4.4,244.4l21.2,21.2L196,96.2l120,120l166-165V120L512,120z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLedger);
export default __webpack_public_path__ + "static/media/AccountLedger.86a3e60a8a4c1c03a887b4c58363543f.svg";
export { ForwardRef as ReactComponent };